import { useEffect } from 'react';
import { useAccountsStore, useUserStore } from '@lib/store';
import { Public } from './public';
import { Private } from './private';

export const Root = () => {
  const userStore = useUserStore();

  const accountsStore = useAccountsStore();

  useEffect(() => {
    if (!userStore.data?.auth) return;
    accountsStore.getAccounts();
  }, [userStore.data?.auth]);

  if (!userStore.data?.auth) return <Public />;
  return <Private />;
};
